export default IconLineHeight => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-line-height" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M3 8l3 -3l3 3" />
  <path d="M3 16l3 3l3 -3" />
  <path d="M6 5l0 14" />
  <path d="M13 6l7 0" />
  <path d="M13 12l7 0" />
  <path d="M13 18l7 0" />
</svg>`;